import { forwardRef, SelectHTMLAttributes } from 'react';

import clsx from 'clsx';

import { CaretDownIcon } from './icons/CaretDownIcon';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: string[];
  enablePlaceholder?: boolean;
  placeholder?: string;
  optionsFull?: any;
  onChange?: any;
  errorMessage?: string;
}

export const Select = forwardRef<HTMLSelectElement, Props>(
  (
    {
      label,
      options,
      placeholder,
      onChange,
      optionsFull,
      errorMessage,
      enablePlaceholder = false,
      ...props
    },
    ref,
  ) => {
    return (
      <fieldset className="flex flex-col gap-1 w-full notranslate">
        <label htmlFor={label} className="text-high-emphasis">
          {label}
        </label>
        <div className="relative">
          <select
            ref={ref}
            id={label}
            defaultValue=""
            onChange={onChange}
            className={clsx(
              'w-full px-4 py-3 rounded-lg text-medium-emphasis border appearance-none focus:ring-1 focus:outline-none notranslate',
              errorMessage
                ? 'border-destructive-main focus:ring-destructive-main'
                : 'border-neutral-lighter focus:ring-primary-main',
            )}
            translate="no"
            lang="zxx"
            {...props}
          >
            {placeholder && (
              <option value="" disabled={!enablePlaceholder} translate="no">
                {placeholder}
              </option>
            )}
            {optionsFull
              ? optionsFull.map(option => (
                  <option key={option.Id} value={option.Id} translate="no">
                    {option.Descricao || option.Sigla || option.Nome}
                  </option>
                ))
              : options.map(option => (
                  <option key={option} value={option} translate="no">
                    {option}
                  </option>
                ))}
          </select>
          <CaretDownIcon className="absolute right-4 bottom-[13px] stroke-neutral-400" />
        </div>
        {errorMessage && (
          <span className="text-xs text-destructive-dark mt-1">
            {errorMessage}
          </span>
        )}
      </fieldset>
    );
  },
);
